import React, { useEffect } from "react";
import { CrossIcon } from "../../svg/cross-icon";
import SearchIcon from "../../svg/search-icon";

interface SearchBarProps {
  placeHolder: string;
  onSearchClick: (searchText: string) => void;
  enableSearchOnChange?: boolean;
  defaultValue?: string;
  id: string;
  onReset?: boolean;
  isDisabled?: boolean;
  shouldLogEvent?: boolean;
  screenName?: string;
}

const SearchBar = (props: SearchBarProps) => {
  const [value, setValue] = React.useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    props.enableSearchOnChange && props.onSearchClick(newValue.trim());
  };

  const handleSearchQuery = () => {
    if (props?.isDisabled) return;
    props.onSearchClick(value.trim());
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearchQuery();
    }
  };

  useEffect(() => {
    if (props.defaultValue) {
      setValue(props.defaultValue);
    }
  }, [props.defaultValue, props.id]);

  useEffect(() => {
    setValue("");
  }, [props.onReset]);

  return (
    <div className="search-bar__container">
      <input
        type="text"
        placeholder={props.placeHolder}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        value={value}
        id={props.id}
        name={props.id}
        disabled={props?.isDisabled}
      />
      {value.trim().length > 0 ? (
        <CrossIcon
          onClick={() => {
            if (props.isDisabled) return;
            setValue("");
            props.onSearchClick("");
          }}
        />
      ) : (
        <SearchIcon onClick={handleSearchQuery} />
      )}
    </div>
  );
};

export default SearchBar;
